import React, { useState } from "react";
import { Card, Form, Button } from "react-bootstrap";
import { FiSend } from "react-icons/fi";

export default function AlwaysHereToHelp() {
  const [messages, setMessages] = useState([
    {
      type: "ai",
      text: "Hello! I'm your AI Attendance Assistant. I can help you analyze attendance patterns, generate reports, and provide insights. How can I assist you today?",
    },
  ]);

  const [input, setInput] = useState("");

  // 🔥 FAKE AI RESPONSE
  const getAIResponse = (msg) => {
    if (msg.toLowerCase().includes("attendance")) {
      return "Your attendance today is 92%. Great job staying consistent!";
    }
    if (msg.toLowerCase().includes("friday")) {
      return "Fridays usually have lower attendance due to early logouts or leave patterns.";
    }
    return "I'm here to help! Please ask anything related to attendance.";
  };

  const handleSend = () => {
    if (!input.trim()) return;

    const userMsg = { type: "user", text: input };
    const aiMsg = { type: "ai", text: getAIResponse(input) };

    setMessages([...messages, userMsg, aiMsg]);
    setInput("");
  };

  return (
    <Card className="ai-card h-100">
      <Card.Body>

        {/* HEADER */}
        <div className="ai-header">
          <div className="ai-left">
            <div className="ai-avatar">✨</div>
            <div>
              <h5>AI Assistant</h5>
              <p>Always here to help</p>
            </div>
          </div>

          <span className="ai-status">• Online</span>
        </div>

        {/* CHAT AREA */}
        <div className="chat-box">
          <p className="chat-title">✨ AI Assistant</p>

          {messages.map((msg, i) => (
            <div
              key={i}
              className={`chat-message ${
                msg.type === "user" ? "user" : "ai"
              }`}
            >
              {msg.text}
            </div>
          ))}

          {/* SUGGESTIONS */}
          <div className="ai-suggestions">
            <button
              onClick={() =>
                setInput("Show me today's attendance summary")
              }
            >
              Show me today's attendance summary
            </button>

            <button
              className="active"
              onClick={() =>
                setInput("Why is attendance low on Fridays?")
              }
            >
              Why is attendance low on Fridays?
            </button>
          </div>
        </div>

        {/* INPUT */}
        <div className="ai-input">
          <Form.Control
            placeholder="Ask me anything about attendance..."
            value={input}
            onChange={(e) => setInput(e.target.value)}
            onKeyDown={(e) => e.key === "Enter" && handleSend()}
          />

          <Button className="send-btn" onClick={handleSend}>
            <FiSend />
          </Button>
        </div>

      </Card.Body>

      {/* ✅ INTERNAL CSS */}
      <style>{`

/* CARD */
.ai-card {
  border-radius: 5px;
  border: 2px solid #e5e7eb;
  overflow: hidden;
}

/* HEADER */
.ai-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: linear-gradient(to right, #111827, #1f2937);
  color: #fff;
  padding: 16px;
  border-radius: 10px;
}

.ai-left {
  display: flex;
  gap: 12px;
}

.ai-avatar {
  width: 45px;
  height: 45px;
  background: #fff;
  color: #111;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
}

.ai-header h5 {
  margin: 0;
  font-weight: 600;
}

.ai-header p {
  margin: 0;
  font-size: 13px;
  color: #d1d5db;
}

.ai-status {
  background: #22c55e;
  color: #fff;
  font-size: 12px;
  padding: 4px 10px;
  border-radius: 20px;
}

/* CHAT BOX */
.chat-box {
  padding: 15px;
  max-height:300px;
  overflow-y: auto;
}

.chat-title {
  color: #0f766e;
  font-weight: 500;
  margin-bottom: 10px;
}

/* MESSAGE */
.chat-message {
  max-width: 80%;
  padding: 10px 14px;
  border-radius: 12px;
  margin-bottom: 10px;
  font-size: 14px;
}

.chat-message.ai {
  background: #f3f4f6;
  color: #374151;
}

.chat-message.user {
  background: #0f766e;
  color: #fff;
  margin-left: auto;
}

/* SUGGESTIONS */
.ai-suggestions {
  margin-top: 10px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.ai-suggestions button {
  border: none;
  background: #f3f4f6;
  padding: 10px 14px;
  border-radius: 20px;
  text-align: left;
  font-size: 14px;
}

.ai-suggestions .active {
  background: #e5e7eb;
}

/* INPUT */
.ai-input {
  display: flex;
  gap: 10px;
  padding: 12px;
  border-top: 1px solid #eee;
}

.ai-input input {
  border-radius: 8px;
}

/* SEND BUTTON */
.send-btn {
  background: #0f766e !important;
  border: none;
  border-radius: 8px;
  padding: 0 16px;
}

/* MOBILE */
@media (max-width: 768px) {

  .ai-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
  }

  .chat-box {
    max-height: 220px;
  }

  .chat-message {
    font-size: 13px;
  }

}

      `}</style>
    </Card>
  );
}